export default __webpack_public_path__ + "static/media/merge-manta-500.13eb6091.svg";